import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './ui/App';
import { useEngine } from './state/engineStore';
import './ui/theme.css';

// Vite emits the worker as its own chunk from this URL form; verified in the production
// build, not just in dev (see docs/ARCHITECTURE.md and the deploy checklist).
const worker = new Worker(new URL('./engine/engine.worker.ts', import.meta.url), {
  type: 'module',
  name: 'setpoint-engine',
});

const params = new URLSearchParams(location.search);
const seedParam = Number(params.get('seed'));

useEngine.getState().attach(worker);
useEngine.getState().boot({
  plantId: params.get('plant') ?? 'water-treatment',
  scenarioId: params.get('scenario'),
  lessonId: params.get('lesson'),
  seed: Number.isFinite(seedParam) && seedParam > 0 ? seedParam : 20_240_101,
  difficulty: (params.get('difficulty') as 'novice' | 'operator' | 'senior') ?? 'operator',
});

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
